<div class="workSpace">
    <div class="headersTab">
        <div class="w3-quarter padreizquierda">
            <div class="w3-row hijoizquierda">
                <span class="w3-text-deep-orange w3-margin-right-filter w3-tituloPrincipal"> <b> {{
                        'menu.'+dataService.moduleSelect | translate }} </b></span>
                <span class="w3-text-deep-orange">&bull;</span>
                <span class="w3-text-orange w3-margin-left-filter w3-subtituloPrincipal"> {{
                    'menu.'+dataService.subModuleSelect | translate }} </span>
            </div>
        </div>

        <!-- Filtros -->
        <div class="w3-rest">
            <div class="w3-noventa2 w3-row">
                <!-- Institución Seleccionada -->
                <div class="w3-third padreizquierda">
                    <div class="w3-row w3-center centradoVertical institucion" (click)="selectInst()" style="cursor: pointer; height: 100%; padding-top: 20px;" >
                        <span>{{instSelecc.alias || 'Seleccionar Institución'}}</span>
                    </div>
                </div>

                <!-- Filtro de Escenarios -->
                <div class="w3-third padreizquierda">
                    <app-filters [name]="'proyFinanciera.escenarioProyeccion.escenario' | translate"
                        [array]="escenarios" [typeFilter]="Filters.ESCENARIOS" [click]="false"
                        [consolidado]="todosEscenarios"
                        (eventClick)="escenarioChange($event)">
                    </app-filters>
                </div>

                <!-- Filtro de Sucursales -->
                <div class="w3-third padreizquierda">
                    <app-filters [name]="'filtros.sucursales' | translate" [array]="sucursales"
                        [typeFilter]="Filters.SUCURSALES" [click]="false" [consolidado]="consolidado"
                        (eventClick)="sucursalChange($event)">
                    </app-filters>
                </div>
            </div>

            <!-- Botón borrar filtros -->
            <div class="w3-rest padreizquierda w3-right" style="height: 7vh; padding-top: 2vh; z-index: 100;">
                <div class="w3-button w3-dropdown-click" style="transform: scale(0.9);" [ngStyle]="{'color':'gray'}"
                    (click)="resetFilters()" matTooltip="{{'tooltips.borrar-filtros'|translate}}">
                    <img src="./../../../../assets/img/eraser.png">
                </div>
            </div>
        </div>
        <!-- FIN Filtros -->
    </div>

<div class="workSpaceTab" style="margin-top: 30px;">
        <div class="w3-white conteTabla" style="padding: auto;">
            <!-- Menú de opciones -->
            <div class="w3-row" style="padding: 10px;">
                <div class="w3-rest w3-right">
                    <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" 
                        [ngStyle]="{'color':'gray'}" 
                        [matMenuTriggerFor]="menuOpciones"
                        style="cursor: pointer;">
                        more_vert
                    </mat-icon>
                </div>
                <mat-menu #menuOpciones="matMenu" xPosition="before">
                    <button mat-menu-item (click)="exportarExcel()">
                        <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">description</mat-icon>
                        <span>{{'menu.Exportar' | translate}}</span>
                    </button>
                </mat-menu>
            </div>

            <div class="w3-scroll" style="height: 70vh; margin-bottom: 1%; overflow-x: auto;">
                <table class="w3-table">
                    <thead>
                        <tr class="w3-table-titleLow w3-center">
                            <th class="w3-border-right-balance marginsH stikyColum" style="width: 110px;">
                                {{'proyFinanciera.escenarioProyeccion.titTab1' | translate}}
                            </th>
                            <th class="w3-border-right-balance marginsH stikyColum" style="min-width: 200px;">
                                {{'proyFinanciera.escenarioProyeccion.titTab2' | translate}}
                            </th>
                            @for (fecha of columnasFechas; track fecha) {
                                <th class="w3-border-right-balance marginsH" style="min-width: 150px;">
                                    {{ fecha }}
                                </th>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        @if (!dataCargando) {
                            @for (cuenta of cuentasVisibles; track cuenta.id; let i = $index) {
                                <tr class="w3-table-trtd" [style.cursor]="tieneHijos(cuenta) ? 'pointer' : 'default'">
                                    <td class="borderAllLow marginsH alinRight">
                                        {{ cuenta.codigo }}
                                    </td>
                                    <td class="borderAllLow marginsH alinLeft" 
                                        (click)="toggleExpansion(cuenta)"
                                        [style.padding-left]="getIndentacion(cuenta)">
                                        @if (tieneHijos(cuenta)) {
                                            <mat-icon class="material-icons-outlined" style="vertical-align: middle; font-size: 18px; margin-right: 5px;">
                                                {{ cuenta.expandido ? 'expand_more' : 'chevron_right' }}
                                            </mat-icon>
                                        }
                                        <span [style.font-weight]="cuenta.nivel === 1 ? 'bold' : 'normal'">
                                            {{ cuenta.nombre }}
                                        </span>
                                    </td>
                                    @for (valor of cuenta.valores; track valor; let j = $index) {
                                        <td class="borderAllLow marginsH alinRight">
                                            {{ valor }}
                                        </td>
                                    }
                                </tr>
                            }
                        }
                    </tbody>
                </table>
                
                @if (cuentasVisibles.length === 0 && !dataCargando) {
                    <div class="w3-row w3-center" style="margin-top: 3vh;">
                        {{'proyFinanciera.configCatalogo.confVacia' | translate}}
                    </div>
                }
                
                @if (dataCargando) {
                    <div class="preview-background" style="margin-top: 15px;">
                        <div class="page">
                            <ngx-skeleton-loader count="5" [theme]="{ 
                                'border-radius': '10px',
                                height: '2vh',
                                width: '70vw',
                            }" />
                            <ngx-skeleton-loader [theme]="{ 
                                'border-radius': '15px',
                                height: '25vh',
                                width: '88vw',
                            }" />
                        </div>
                    </div>
                }
            </div>
        </div>
    </div>
</div>